import {useGrpcRequest, type CacheKeyConfig} from '@aboutyou/data-fetcher';
import {ArticleDetailService_GetRecommendationsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import {useProductIdFromSlug} from '../../../../features/ProductUrl';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useSelectedTargetGroup} from '../../../../shared-deprecated/useSelectedTargetGroup';
import {
  useKeepPreviousRecommendationsData,
  useUpdateKeepPreviousData,
} from './useKeepPreviousRecommendationsData';

const transformCacheKey = (config: CacheKeyConfig) => {
  return {
    ...config,
    params: {
      ...config.params,
      // Exclude lastSeenProductIds from cache key to prevent re-fetches when only this changes
      // The backend still receives this data for personalization
      lastSeenProductIds: undefined,
    },
  };
};

export const useRecommendationsData = ({
  requestEnabled,
  lastSeenProductIds,
}: {
  requestEnabled: boolean;
  lastSeenProductIds: number[];
}) => {
  const productId = useProductIdFromSlug();
  const session = useOptionalSession();
  const {targetGroup} = useSelectedTargetGroup();
  const reductionsState = useReductionsStateRequestParameter();

  const {keepPreviousData, updateKeepPreviousData} =
    useKeepPreviousRecommendationsData();

  const request = useGrpcRequest(
    ArticleDetailService_GetRecommendationsLazy,
    {
      productId: productId!,
      lastSeenProductIds,
      session,
      targetGroup,
      reductionsState,
    },
    {
      keepPreviousData,
      disabled: !requestEnabled,
      transformCacheKey,
    },
  );

  useUpdateKeepPreviousData(request, updateKeepPreviousData, productId);

  return request;
};
